<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div :class="['modal_new_game', gameType.toLowerCase(), 'modal_cont']" id="newGame_modal">
        <div class="newGame_content_top">
          <img class="x_close" src="static/images/games/Icon-Close.png" @click="$emit('close')">
          <img v-if="gameType === 'ATTENTION'" class="top_icon" src="static/images/games/icon-attention.png" alt="">
          <img v-if="gameType === 'LOGIC'" class="top_icon" src="static/images/games/icon-logic.png" alt="">
          <img v-if="gameType === 'MEMORY'" class="top_icon" src="static/images/games/icon-memory.png" alt="">
          <p v-if="gameType === 'ATTENTION'">{{ getTranslations.home_modal_game_attention }}</p>
          <p v-if="gameType === 'LOGIC'">{{ getTranslations.home_modal_game_logic }}</p>
          <p v-if="gameType === 'MEMORY'">{{ getTranslations.home_modal_game_memory }}</p>
        </div>
        <div class="newGame_content_center">
          <p>{{ getTranslations.home_pre_game_modal_you_selected_to_play }}</p>
          <span v-if="gameType === 'ATTENTION'">{{ getTranslations.home_pre_game_modal_an_attention }}</span>
          <span v-if="gameType === 'LOGIC'">{{ getTranslations.home_pre_game_modal_a_logic }}</span>
          <span v-if="gameType === 'MEMORY'">{{ getTranslations.home_pre_game_modal_a_memory }}</span>
          <div class="newGame_border"></div>
          <p>{{ getTranslations.home_pre_game_modal_choose_difficulty }}</p>
          <div class="newGame_buttons">
            <button type="button" class="newGame_btn" @click.prevent="gameMode = 'EASY'" style="cursor:pointer">
              <img src="static/images/games/easy0.svg">
              <p>{{ getTranslations.home_pre_game_modal_easy }}</p>
            </button>
            <button type="button" class="newGame_btn" @click.prevent="gameMode = 'HARD'" style="cursor:pointer">
              <img src="static/images/games/hard0.svg">
              <p>{{ getTranslations.home_pre_game_modal_hard }}</p>
            </button>
          </div>

          <button type="button" @click.prevent="playGameMethod" v-if="!!gameType && !!gameMode" class="newGame_start_btn">
            {{ getTranslations.home_modal_game_new_game }}
          </button>
        </div>
        <div class="newGame_content_bottom" v-if="gameType === 'ATTENTION'">
          <p>{{ getTranslations.home_pre_game_benefits_attention }}</p>
          <span>
           {{ getTranslations.home_pre_game_benefits_desc_attention }}
        </span>
        </div>

        <div class="newGame_content_bottom" v-if="gameType === 'LOGIC'">
          <p>{{ getTranslations.home_pre_game_benefits_logic }}</p>
          <span>
          {{ getTranslations.home_pre_game_benefits_desc_logic }}
        </span>
        </div>

        <div class="newGame_content_bottom" v-if="gameType === 'MEMORY'">
          <p>{{ getTranslations.home_pre_game_benefits_memory }}</p>
          <span>
           {{ getTranslations.home_pre_game_benefits_desc_memory }}
        </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import NewGameMixin from '@/common/mixins/home';

export default {
  name: 'new-game-modal-with-game-mode',
  mixins: [NewGameMixin],
  data() {
    return {
      gameMode: null,
    };
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    playGameMethod() {
      this.getUserLoginDetails().then(() => {
        this.playGame(this.gameType, this.gameMode);
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'gameType',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/postgame/NewGameModalWithGameMode.vue